const galleryGrid = () => {
    var trigger = document.querySelectorAll('.gallery-grid__mobile-trigger');
    if(trigger){
        trigger.forEach(el => {
            el.addEventListener('click', () => {
                var gallery = el.dataset.gallery;
                fsLightboxInstances[gallery].open(5);
            })
        })
    }
    
    
};

export default galleryGrid;
